import { render, staticRenderFns } from "./InstitutionManagement.vue?vue&type=template&id=1a6ef3d8"
import script from "./InstitutionManagement.vue?vue&type=script&lang=js"
export * from "./InstitutionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports